import { X, Funnel } from "lucide-react";
import { useState } from "react";
import { Button } from "../button/button.js";

type Props = {
  filterCount: number;
  showClear?: boolean;
  onClearFilters: () => void;
  onOpenFilters: () => void;
};

export const FilterButton = ({
  filterCount,
  showClear = true,
  onClearFilters,
  onOpenFilters,
}: Props) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div className="relative inline-block" onMouseLeave={() => setIsHovering(false)}>
      <Button icon={<Funnel />} size="icon_sm" variant="ghost" onClick={onOpenFilters} />

      {filterCount > 0 && (
        <div
          className="absolute -top-2.5 -right-2.5 flex h-5 w-5 items-center justify-center"
          onMouseEnter={() => setIsHovering(true)}
        >
          {!isHovering || !showClear ? (
            <div className="bg-gxe-primary flex h-full w-full items-center justify-center rounded-full text-[12px] font-semibold text-white">
              {filterCount}
            </div>
          ) : (
            <>
              {showClear && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    onClearFilters();
                  }}
                  variant={"destructive"}
                  size={"icon_sm"}
                  className="flex h-full w-full items-center justify-center rounded-full !text-white transition-colors hover:!bg-red-700"
                  aria-label="Clear filters"
                >
                  <X className="h-4 w-4" />
                </Button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
